export function getImageDimensions(file: File): Promise<{ height?: number; width?: number }> {
  return new Promise((resolve) => {
    if (!file.type.startsWith('image/')) {
      resolve({ width: undefined, height: undefined });
    }

    const img = new Image();

    img.onload = function () {
      resolve({ width: img.width, height: img.height });
    };

    img.onerror = function () {
      // Do not reject promise, as some images types can't be loaded by browser (.cr3, .dng, etc.)
      // reject(new Error('Failed to load image.'));
      resolve({ width: undefined, height: undefined });
    };

    img.src = URL.createObjectURL(file);
  });
}
